import { render, staticRenderFns } from "./clientsComponent.vue?vue&type=template&id=4cdfed60&scoped=true&"
import script from "./clientsComponent.vue?vue&type=script&lang=js&"
export * from "./clientsComponent.vue?vue&type=script&lang=js&"
import style0 from "./clientsComponent.vue?vue&type=style&index=0&id=4cdfed60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfed60",
  null
  
)

export default component.exports